import * as React from "react";
import Layout from "../Layout";
import Content from "./Content";
import { RootState } from "../../store/configureStore";
import { useSelector } from "react-redux";

const Ideas: React.FC = () => {
  const { breadcrumbs = [] } = useSelector(
    (state: RootState) => state.IdeaList,
  );

  return (
    <Layout breadcrumbs={breadcrumbs} isFooterVisible={false}>
      <Content />
    </Layout>
  );
};

export default Ideas;
